var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72852 10.0712C7.0684 10.5256 7.50203 10.9015 8 11.1736C8.49796 11.4456 9.04861 11.6074 9.6146 11.648C10.1806 11.6885 10.7487 11.6068 11.2803 11.4085C11.812 11.2102 12.2948 10.8999 12.6959 10.4985L15.0702 8.12424C15.7911 7.37791 16.1899 6.37831 16.1809 5.34076C16.1719 4.3032 15.7557 3.31069 15.022 2.577C14.2883 1.84331 13.2958 1.42713 12.2583 1.41812C11.2207 1.4091 10.2211 1.80796 9.47479 2.52879L8.11353 3.88215",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4525 7.92871C10.1127 7.47432 9.67903 7.09835 9.18107 6.82629C8.6831 6.55423 8.13245 6.39244 7.56646 6.35191C7.00047 6.31137 6.43238 6.39304 5.90073 6.59136C5.36908 6.78968 4.8863 7.10002 4.48513 7.50133L2.11083 9.87564C1.38999 10.622 0.991133 11.6216 1.00015 12.6591C1.00917 13.6967 1.42534 14.6892 2.15903 15.4229C2.89272 16.1566 3.88523 16.5727 4.92279 16.5818C5.96035 16.5908 6.95994 16.1919 7.70627 15.4711L9.05962 14.1177",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.9c35e17e1861817d3badbf734610a963.svg";
export { ForwardRef as ReactComponent };